import {gql} from '@apollo/client';
import React from 'react';

import {NavStoreRegistry} from 'constants/RegistryConstants';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import StorableCreateMenu from 'samples/sidepanel/StorableCreateMenu';

import {
  StorableCreateMenuQuery,
  StorableCreateMenuQueryVariables,
} from './__generated/StorableCreateMenuQuery';

export const STORABLE_CREATE_MENU_QUERY = gql`
  query StorableCreateMenuQuery($listedLocationId: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    location(id: $listedLocationId) {
      ... on LocationNode {
        ...LocationSummaryGraphQL
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('LocationSummary').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export interface QueryingStorableCreateMenuProps {
  registry: NavStoreRegistry;
  isExpanded: boolean;
  listedLocationId: string | null;
}

export default function QueryingStorableCreateMenu(props: QueryingStorableCreateMenuProps): JSX.Element {
  const {listedLocationId} = props;
  const result = useSkippableBenchlingQuery<StorableCreateMenuQuery, StorableCreateMenuQueryVariables>(
    STORABLE_CREATE_MENU_QUERY,
    {
      skip: listedLocationId == null,
      variables: {listedLocationId: listedLocationId!},
    }
  );

  let listedLocation = null;
  if (result.type === QueryResultType.SUCCESS && !isInaccessible(result.data.location)) {
    listedLocation = result.data.location;
  }

  return <StorableCreateMenu listedLocation={listedLocation} {...props} />;
}
